import { render, staticRenderFns } from "./OsdiIconButton.vue?vue&type=template&id=40ae4aed&scoped=true&"
import script from "./OsdiIconButton.vue?vue&type=script&lang=ts&"
export * from "./OsdiIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./OsdiIconButton.vue?vue&type=style&index=0&id=40ae4aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae4aed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
